var map = {
	"./font1.png": "159f",
	"./font2.png": "21a7",
	"./font3.png": "4641",
	"./font4.png": "6dd3",
	"./font5.png": "ddd0",
	"./font6.png": "7c1c",
	"./font7.png": "b630",
	"./font8.png": "1cde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d58";